<template>
    <div class="cz2__steps-options__actions--share">
        <button
            type="button"
            :disabled="isDisabled"
            class="cz2__btn--share"
        >
            <div class="cz2__share-btn-content-wrapper">
                <loading-spinner
                    v-if="isDisabled"
                    :spinner-size="spinnerSize"
                    class="cz2__btn-spinner"
                />

                <img
                    v-else
                    :src="icon"
                    alt=""
                    class="cz2__share-btn-icon"
                >
            </div>

            <span class="cz2__btn--share-label">
                {{ buttonCopy }}
            </span>
        </button>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__btn--share {
            font-size: 8px;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;

            &:focus {
                .cz2__share-btn-content-wrapper {
                    outline: 2px solid white !important;
                }
            }
        }

        .cz2__share-btn-content-wrapper {
            border-radius: 1000px;
            width: 32px;
            height: 32px;
            background-color: rgba(255, 255, 255, 0.16);
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .cz2__share-btn-icon {
            width: 16px;
            height: 16px;
        }

        .cz2__btn-spinner {
            border-color: rgba(255, 255, 255, 0.4);
            border-bottom-color: white;
        }

        .cz2__btn--share-label {
            visibility: hidden;
            height: 0;
        }

        @include respond-above(md) {
            .cz2__btn--share-label {
                visibility: visible;
                height: auto;
            }
        }

        @include respond-above(lg) {
            .cz2__share-btn-content-wrapper {
                width: 40px;
                height: 40px;
            }

            .cz2__share-btn-icon {
                width: 20px;
                height: 20px;
            }
        }
    }
</style>

<script>
    import LoadingSpinner from './ui/LoadingSpinner.vue';

    export default {
        components: {
            LoadingSpinner,
        },

        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },

            buttonCopy: {
                type: String,
                default: '',
            },

            icon: {
                type: String,
                default: '',
            },
        },

        computed: {
            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            spinnerSize() {
                return this.isMobile ? 16 : 20;
            },
        },
    };
</script>
